import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { PageMeta } from "@/components/common/PageMeta";
import { Wordmark } from "@/components/layout/Header";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      const from = location.state?.from;
      navigate(from ? `${from.pathname}${from.search || ""}` : "/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--ivory)] px-4">
      <PageMeta title="Admin sign in" />
      <div className="w-full max-w-sm rounded-3xl border border-[var(--line)] bg-[var(--paper)] p-8">
        <Wordmark />
        <h1 className="mt-6 font-display text-2xl font-bold text-navy">Admin sign in</h1>
        <p className="mt-1 text-sm text-[var(--mineral)]">Authorised users only.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          {error && <div role="alert" className="rounded-lg border border-[var(--error)]/30 bg-[var(--error)]/10 p-3 text-sm text-[var(--error)]" data-testid="admin-login-error">{error}</div>}
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-navy">Email</span>
            <input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required className="w-full rounded-xl border border-[var(--line)] px-4 py-2.5 text-sm outline-none focus:border-[var(--cobalt)]" />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-navy">Password</span>
            <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required className="w-full rounded-xl border border-[var(--line)] px-4 py-2.5 text-sm outline-none focus:border-[var(--cobalt)]" />
          </label>
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="btn-transition w-full rounded-full bg-[var(--navy)] px-5 py-3 text-sm font-semibold text-white hover:bg-[var(--cobalt)] disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
